import React from "react";
import { Dialog, DialogProps } from "@emisgroup/ui-dialog";

interface CustomDialogProps {
  /**
   * Children to render
   */
  children?: React.ReactNode;
  /**
   * Class Name
   */
  className?: string;
}

type DlgProps = DialogProps & CustomDialogProps;

/**
 * Responsible for rendering the dialog component
 * @returns dialog element
 */
export const UIDialog: React.FC<DlgProps> = (props: DlgProps) => {

  const { className, children } = props;

  return (
    <Dialog
      className={`${className} ui-dialog`}
      {...props}
    >
      {children}
    </Dialog>
  );
};
